// extracted by mini-css-extract-plugin
export default {"cls1":"WorkCard-cls1_pjD","cls2":"WorkCard-cls2_YE_ WorkCard-cls1_pjD"};